import constants from "../../commonUtils/constants";
import * as actionTypes from "./actionTypes";

const initialState = {
  loading: false,
  filters: { keyword: "" },
  DataCategoriesList: { data: [], pagination: { currentPage: 1, perPage: constants.tableUI.defaultPerpage, total: 0 }},
  errors: { title: "" },
  errorMessage: "",
};

const DataCategory = (state = initialState, action) => {
  switch (action.type) {
    case actionTypes.SET_LOADING:
      return {
        ...state,
        loading: action.payload,
      };
    case actionTypes.SET_ERRORS:
      return {
        ...state,
        errors: action.payload,
      };
    case actionTypes.SET_FILTERS:
      return {
        ...state,
        filters: action.payload,
      };
    case actionTypes.GET_DATA_CATEGORIES_SUCCESS:
      return {
          ...state,
          loading: false,
          DataCategoriesList: action.payload,
          // errors: { dataCategoryId: "", sourceType: "", files: "" },
          // errorMessage: "",
      };
    case actionTypes.GET_DATA_CATEGORIES_FAILURE:
      return {
          ...state,
          loading: false,
          errors: action.payload.data,
          errorMessage: action.payload.message
      };
    case actionTypes.CREATE_DATA_CATEGORY_SUCCESS:
      return {
          ...state,
          loading: false,
          // DataCategoriesList: action.payload,
          // errors: { dataCategoryId: "", sourceType: "", files: "" },
          // errorMessage: "",
      };
    case actionTypes.CREATE_DATA_CATEGORY_FAILURE:
      return {
          ...state,
          loading: false,
          errors: action.payload.data,
          errorMessage: action.payload.message
      };
    case actionTypes.UPDATE_DATA_CATEGORY_SUCCESS:
      return {
          ...state,
          loading: false,
          // DataCategoriesList: action.payload,
          // errors: { dataCategoryId: "", sourceType: "", files: "" },
          // errorMessage: "",
      };
    case actionTypes.UPDATE_DATA_CATEGORY_FAILURE:
      return {
          ...state,
          loading: false,
          errors: action.payload.data,
          errorMessage: action.payload.message
      };
    case actionTypes.DELETE_DATA_CATEGORY_SUCCESS:
      return {
          ...state,
          loading: false,
          errorMessage: "",
      };
    case actionTypes.DELETE_DATA_CATEGORY_FAILURE:
      return {
          ...state,
          loading: false,
          errors: action.payload.data,
          errorMessage: action.payload.message
      };
    case actionTypes.UPDATE_DATA_CATEGORY_STATUS_SUCCESS:
      return {
          ...state,
          loading: false,
          errorMessage: "",
      };
    case actionTypes.UPDATE_DATA_CATEGORY_STATUS_FAILURE:
      return {
          ...state,
          loading: false,
          errors: action.payload.data,
          errorMessage: action.payload.message
      };
    default:
        return state;
  }
};

export default DataCategory;
